export default __webpack_public_path__ + "static/media/Inklink Exterior.1adeba3c.jpg";